














import { Component, Prop } from 'vue-property-decorator';
import Vue from '@/vue.type';

@Component
export default class SearchBar extends Vue {
  @Prop() value: any = '';
}

